import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'; // 导入中文语言包

// 设置 dayjs 的全局语言为中文
dayjs.locale('zh-cn');
